const NFL_POSITIONS = {
  QB: '#be1e2d',
  RB: '#1b55a7',
  WR: '#552d90',
  TE: '#f06b00',
  D: '#007c45',
  K: '#5a4a42',
};

export const COLORS = {
  BLACK: '#000000',
  NFL_POSITIONS,
  PRIMARY_GREEN: '#8bc53f',
  SECONDARY_GRAY: '#646464',
  DISABLED_GRAY: '#CECECE',
  WHITE: '#FFFFFF',
  SUCCESS: '#118652',
  WARN: '#DDBF19',
  ERR: '#BC2A2A',
};
